module.exports = __webpack_public_path__ + "img/Elegance.eb5e03e7.svg";